<template>
  <v-card flat tile class="form-container">
    <v-layout justify-center align-center>
      <v-flex xs6 xl4>
        <!--<v-img :src="require('@/assets/nt.svg')"></v-img>-->
        <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve"  version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
             viewBox="0 0 20280.75 18500.48"
             xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="logo">
  <path class="logo-text" d="M6579.65 4360.49l-3522.66 0 0 -4360.49 -3056.99 0 0 11483.29 3056.99 0 0 -4360.6 3522.66 0 0 -2762.21zm1333.36 -4360.49l0 11483.29 3057.02 0 0 -8721.08 4655.47 0c641.26,0 1068.1,105.99 1280.19,318.04 212.14,212.14 318.04,638.94 318.04,1280.24l0 7122.81 3057.03 0 0 -7122.81c0,-1499.91 -268.83,-2581.08 -806.79,-3243.2 -610.45,-744.88 -1655.4,-1117.28 -3134.69,-1117.28l-8426.27 0zm4588.58 11483.29l3083.62 0 0 -7184.39 -3083.62 0 0 7184.39zm-10591.07 3710.34l0 -2355.44 -501.46 0 0 964.04 -907.59 0 0 -964.04 -501.47 0 0 2355.44 501.47 0 0 -971.12 907.59 0 0 971.12 501.46 0zm2779.19 0l-974.7 -2355.44 -575.61 0 -974.66 2355.44 519.11 0 218.97 -547.36 1024.08 0 218.97 547.36 543.84 0zm-897 -967.64l-748.67 0 370.82 -967.56 377.85 967.56zm3386.6 1391.4l0 -596.82c0,-65.93 -23.54,-123.61 -71.19,-173.03 -47.13,-49.42 -100.06,-74.15 -158.33,-74.15l0 -1935.2 -1755.14 0 0 1112.38c0,148.33 -11.74,294.26 -35.28,437.9 -23.58,143.59 -62.38,271.9 -116.54,384.92 -35.31,0 -69.45,7.63 -102.39,22.95 -32.99,15.29 -61.82,34.72 -86.56,58.27 -24.73,23.54 -44.71,50.02 -60.05,79.48 -15.28,29.39 -22.91,58.24 -22.91,86.48l0 596.82 473.18 0 0 -324.88c0,-28.28 9.99,-51.78 30.02,-70.63 19.99,-18.84 43.57,-28.24 71.82,-28.24l1265.41 0c25.88,0 47.64,9.99 66.49,29.98 18.84,20.03 28.28,42.99 28.28,68.89l0 324.88 473.18 0zm-730.97 -844l-911.11 0c21.18,-25.92 40.02,-69.45 56.49,-130.68 16.51,-61.19 30.03,-130.64 40.65,-208.35 10.54,-77.66 18.81,-159.51 24.68,-245.43 5.89,-85.92 8.85,-166.55 8.85,-241.88l0 -688.64 780.44 0 0 1514.97zm6603.65 -1935.2l-656.82 0 -900.53 1161.8 851.11 1193.64 660.37 0 -935.84 -1193.64 981.7 -1161.8zm-1574.96 2355.44l0 -2355.44 -501.46 0 0 2355.44 501.46 0zm-519.12 -1193.64l-900.52 -1161.8 -656.83 0 981.7 1161.8 -935.8 1193.64 660.37 0 851.07 -1193.64zm4241.18 1193.64l0 -2355.44 -501.46 0 0 964.04 -907.6 0 0 -964.04 -501.46 0 0 2355.44 501.46 0 0 -971.12 907.6 0 0 971.12 501.46 0zm2779.19 0l-974.7 -2355.44 -575.61 0 -974.63 2355.44 519.12 0 218.92 -547.36 1024.09 0 218.97 547.36 543.84 0zm-897 -967.64l-748.63 0 370.78 -967.56 377.85 967.56zm3199.48 967.64l0 -2355.44 -1115.94 0c-193.06,0 -350.21,23.54 -471.48,70.63 -121.19,47.09 -215.96,105.94 -284.27,176.58 -68.26,70.59 -114.75,147.7 -139.44,231.29 -24.73,83.55 -37.1,163.04 -37.1,238.37 0,58.86 5.3,119.47 15.89,181.88 10.58,62.38 30.02,122.43 58.27,180.1 28.24,57.67 67.12,110.06 116.54,157.15 49.45,47.09 111.83,83.55 187.17,109.46 -68.27,18.85 -127.72,48.88 -178.32,90.07 -50.64,41.2 -92.99,90.62 -127.12,148.29 -34.17,57.68 -59.46,121.83 -75.93,192.46 -16.47,70.64 -24.73,144.79 -24.73,222.49l-3.56 356.68 529.74 0 0 -335.51c0,-167.14 51.79,-301.93 155.33,-404.31 103.62,-102.44 267.24,-153.64 490.91,-153.64l402.54 0 0 893.46 501.5 0zm-501.5 -1313.69l-667.41 0c-138.9,0 -233.67,-27.07 -284.31,-81.23 -50.6,-54.12 -75.92,-135.37 -75.92,-243.66 0,-94.17 25.32,-167.14 75.92,-218.92 50.64,-51.84 145.41,-77.71 284.31,-77.71l667.41 0 0 621.52zm-10527.03 -1041.75l-847.51 0c-145.97,0 -282.53,21.77 -409.66,65.34 -127.08,43.53 -237.77,111.79 -331.94,204.82 -94.17,92.99 -168.33,213.63 -222.45,361.97 -54.16,148.29 -81.26,326.06 -81.26,533.22 0,244.84 31.21,444.37 93.58,598.55 62.42,154.22 148.34,274.87 257.81,361.97 109.46,87.1 240.13,147.15 391.99,180.1 151.85,32.99 317.25,49.46 496.16,49.46l653.27 0 0 -420.24 -632.1 0c-120.05,0 -221.89,-9.44 -305.48,-28.28 -83.55,-18.81 -152.4,-49.42 -206.56,-91.81 -54.16,-42.39 -95.36,-97.69 -123.57,-165.96 -28.28,-68.3 -47.13,-153.03 -56.53,-254.24l1324.24 0 0 -420.24 -1324.24 0c9.4,-101.25 22.95,-187.17 40.61,-257.8 17.66,-70.63 49.45,-128.3 95.32,-173.06 45.95,-44.72 110.69,-76.52 194.25,-95.33 83.58,-18.85 197.16,-28.25 340.79,-28.25l653.27 0 0 -420.23zm-5242.32 3727.08l0 -420.24 -1959.93 0 0 420.24 716.86 0 0 1935.21 501.47 0 0 -1935.21 741.6 0zm2058.76 1935.21l0 -420.24 -632.09 0c-120.05,0 -221.89,-9.44 -305.48,-28.29 -83.55,-18.8 -152.44,-49.41 -206.57,-91.8 -54.16,-42.39 -95.36,-97.69 -123.61,-165.96 -28.24,-68.3 -47.09,-153.04 -56.52,-254.28l1324.27 0 0 -420.2 -1324.27 0c9.43,-101.25 22.99,-187.17 40.64,-257.8 17.62,-70.63 49.42,-128.3 95.33,-173.07 45.94,-44.71 110.69,-76.52 194.24,-95.32 83.59,-18.85 197.16,-28.25 340.79,-28.25l653.27 0 0 -420.24 -847.51 0c-145.96,0 -282.52,21.77 -409.65,65.31 -127.12,43.57 -237.78,111.83 -331.95,204.86 -94.17,92.99 -168.32,213.63 -222.48,361.93 -54.13,148.33 -81.23,326.06 -81.23,533.25 0,244.85 31.21,444.38 93.59,598.56 62.41,154.22 148.33,274.87 257.8,361.97 109.47,87.1 240.14,147.15 391.95,180.1 151.86,32.99 317.26,49.46 496.21,49.46l653.27 0zm2387.24 0l-798.13 -1190.09 798.13 -1165.36 -607.41 0 -501.46 773.37 -462.63 -773.37 -614.44 0 773.37 1165.36 -801.65 1190.09 596.82 0 508.53 -808.72 519.07 808.72 589.79 0zm2168.27 0l0 -2355.45 -501.46 0 0 964.05 -907.6 0 0 -964.05 -501.46 0 0 2355.45 501.46 0 0 -971.16 907.6 0 0 971.16 501.46 0zm2528.47 0l0 -2355.45 -639.2 0 -939.36 1755.07 0 -1755.07 -473.17 0 0 2355.45 614.44 0 964.04 -1726.86 0 1726.86 473.26 0zm2563.75 -2355.45l-656.79 0 -900.56 1161.8 851.1 1193.65 660.38 0 -935.84 -1193.65 981.7 -1161.8zm-1574.97 2355.45l0 -2355.45 -501.5 0 0 2355.45 501.5 0zm4124.65 0l-974.67 -2355.45 -575.6 0 -974.67 2355.45 519.12 0 218.96 -547.36 1024.09 0 218.92 547.36 543.85 0zm-896.97 -967.64l-748.67 0 370.82 -967.56 377.85 967.56z"/>
 </g>
</svg>

      </v-flex>
    </v-layout>
    <v-card-text>
      <v-form ref="form" v-model="valid" @submit.prevent="login" class="mt-4">
        <v-text-field
          prepend-icon="mdi-account"
          autofocus
          name="username"
          label="Логин"
          id="username"
          :rules="validationRules.username"
          v-model="user.username"
          autocomplete="off"
          autocapitalize="none"
          type="text"
          required/>
        <v-text-field
          prepend-icon="mdi-lock"
          name="password"
          :rules="validationRules.password"
          label="Пароль"
          id="password"
          autocomplete="off"
          v-model="user.password"
          type="password"
          required/>
        <v-btn
          large
          block
          depressed
          color="primary"
          type="submit"
          :disabled="_isLoading || !valid"
          :loading="_isLoading">
          Войти
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'login',

  data () {
    return {
      valid: true,
      validationRules: {
        username: [
          v => !!v || 'Введите логин'
        ],
        password: [
          v => !!v || 'Введите пароль'
        ]
      },
      user: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapGetters('auth', {
      _isLoading: 'isLoading',
      _isLoggedIn: 'isLoggedIn'
    })
  },
  methods: {
    ...mapActions('auth', {
      _login: 'login'
    }),
    async login () {
      if (this.$refs.form.validate()) {
        await this._login(this.user)
        if (this._isLoggedIn) {
          this.$refs.form.reset()
          this.$router.push({ name: 'dashboard' })
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  @require '~vuetify/src/stylus/settings/_theme.styl'
  .form-container
    background: transparent !important

  .logo-text {fill: var(--v-primary-base)}
</style>
